var React = require('react');

function Tablet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 3c0-2 .988-3 2.963-3h74.074C79.012 0 80 1 80 3v53c0 2-.988 3-2.963 3H2.963C.988 59 0 58 0 56V3z"}));
}

Tablet.defaultProps = {"viewBox":"0 0 80 59"};

module.exports = Tablet;

Tablet.default = Tablet;
